import { UserRole } from '@shared/types/user';
import { DIVIDER, MenuItem } from './menu-item.type';

export const BOARD_MENU_ITEMS: MenuItem[] = [
  {
    name: 'header.client',
    url: '/client',
    icon: 'Gear',
    permission: [UserRole.Admin],
  },
  {
    name: 'header.clientBI',
    url: '/client-bi',
    icon: 'analytics',
    permission: [UserRole.Admin, UserRole.ClientAdmin, UserRole.Manager],
  },
  {
    name: 'header.users',
    url: '/users',
    icon: 'Users',
    permission: [
      UserRole.Admin,
      UserRole.Manager,
      UserRole.ClientAdmin,
      UserRole.Supervisor,
      UserRole.CustomerSupport,
    ],
  },
  {
    name: 'header.games',
    url: '/board-games',
    icon: 'Games',
    permission: [
      UserRole.Admin,
      UserRole.Manager,
      UserRole.ClientAdmin,
      UserRole.Supervisor,
      UserRole.CustomerSupport,
    ],
  },
  {
    name: 'Stages',
    url: '/board-stages',
    icon: 'Stages',
    permission: [
      UserRole.Admin,
      UserRole.Manager,
      UserRole.ClientAdmin,
      UserRole.Supervisor,
      UserRole.CustomerSupport,
    ],
  },
  DIVIDER,
  {
    name: 'header.pathConfig',
    url: '/path-config',
    icon: 'Tiles',
    permission: [
      UserRole.Admin,
      UserRole.Supervisor,
      UserRole.Manager,
      UserRole.ClientAdmin,
    ],
  },
  {
    name: 'header.actionsConfig',
    url: '/actions-config',
    icon: 'BoardActions',
    permission: [
      UserRole.Admin,
      UserRole.Supervisor,
      UserRole.Manager,
      UserRole.ClientAdmin,
    ],
  },
  {
    name: 'header.boardCollectibles',
    url: '/board-collectibles',
    icon: 'Diamond',
    permission: [
      UserRole.Admin,
      UserRole.Supervisor,
      UserRole.Manager,
      UserRole.ClientAdmin,
    ],
  },
  {
    name: 'header.prizes',
    url: '/prizes',
    icon: 'Gift',
    permission: [
      UserRole.Admin,
      UserRole.Supervisor,
      UserRole.Manager,
      UserRole.ClientAdmin,
    ],
  },
  DIVIDER,
  {
    name: 'header.assets',
    url: '/assets',
    icon: 'Upload',
    permission: [UserRole.Admin],
  },
  {
    name: 'header.theme',
    url: '/board-theme',
    icon: 'Droplet',
    permission: [UserRole.Admin, UserRole.ClientAdmin],
  },
  {
    name: 'header.tokenValidation',
    url: '/token-validation',
    icon: 'Security',
    permission: [
      UserRole.Admin,
      UserRole.Manager,
      UserRole.ClientAdmin,
      UserRole.Supervisor,
    ],
  },
  {
    name: 'header.tasks',
    url: '/tasks',
    icon: 'Tasks',
    permission: [UserRole.Admin],
  },
  {
    name: 'header.preview',
    url: '/board-preview',
    icon: 'Eye',
    permission: [UserRole.Admin],
  },
];
